export default {
  calcSubtotal() {
    const productsList = $(".js-field-dropdown__field_btn");
    let subtotal = 0;

    for (let i = 0; i < productsList.length; i++) {
      let ticket = $(productsList[i]).data("tickets");

      if (!ticket) continue;

      subtotal += ticket.totalCost;
    }

    $(".js-subtotal-cost").text("$".concat(subtotal.toFixed(2)));
  },

  calcDiscount() {
    const subtotal = Number.parseFloat(
      $(".js-subtotal-cost")
        .text()
        .replace("$", "")
    );
    const discountValue = Number.parseFloat($(".js-discount-value").val());
    const discountBlock = $(".js-subtotal-discount");
    const discount = ((subtotal * discountValue) / 100).toFixed(2);
    discountBlock.html(`$${discount}`);
  },

  calcTotal() {
    const subtotal = Number.parseFloat(
      $(".js-subtotal-cost")
        .text()
        .replace("$", "")
    );
    const taxBlock = $(".js-subtotal-tax")
      .text()
      .replace("$", "");
    const discountBlock = $(".js-subtotal-discount")
      .text()
      .replace("$", "");

    const tax = taxBlock ? Number.parseFloat(taxBlock) : 0;
    const discount = discountBlock ? Number.parseFloat(discountBlock) : 0;

    const total = (subtotal + tax - discount).toFixed(2);

    $(".js-total-cost").text("$".concat(total));
  },

  clearTicketsField(form) {
    const fieldWrap = $(form).find(".js-field-dropdown__tickets");
    const fieldLabel = $(fieldWrap).find(".js-field-dropdown__label");
    const feildBtn = $(fieldWrap).find(".js-field-dropdown__field_btn");
    const fieldInputNumber = $(fieldWrap).find(
      ".js-field-dropdown-tickets__field"
    );
    const fieldDecrBtn = $(fieldWrap).find(
      '.js-field-dropdown-tickets__btn[data-incr="false"]'
    );
    const fieldIncrBtn = $(fieldWrap).find(
      '.js-field-dropdown-tickets__btn[data-incr="true"]'
    );
    const $totalCostWrap = $(form).find(".js-field-dropdown__subtotal-wrap");
    const $totalCostBlock = $(form).find(".js-field-dropdown__subtotal");

    fieldLabel.addClass("is-disabled");
    feildBtn.attr("disabled", true);
    feildBtn.attr("value", "Select Tickets");
    fieldInputNumber.val(0);
    fieldDecrBtn.addClass("is-disabled");
    fieldIncrBtn.removeClass("is-disabled");

    $(".js-book-now").attr("disabled", true);
    $('.js-field-dropdown__field_btn[name="tickets"]').data("tickets", null);

    $($totalCostWrap).removeClass("is-show");
    $($totalCostBlock).text("$0");
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/tickets-form/calc-worth.js